<template>
    <div class="mPage">
        <div class="top">
            <img src="../img/m/m_logo.png" alt="" class="logo">
            <slot></slot>
        </div>
        <div class="content">
            <div class="title">
                <img src="../img/m/m_title.png" alt="">
                <div class="topic">
                    · 新时代国际中文教育的创新与发展 ·
                </div>
                <div class="enTopic">
                    Innovation and Development of International Chinese Language Education in the New Era
                </div>
            </div>
            <div class="language">
                <div class="item" @click="changeLanguage('cn')">
                    <div :class="{'currentBg': $i18n.locale=='cn'}"></div>
                    <span :class="{'current': $i18n.locale=='cn'}">
                        中文
                    </span>
                    
                </div>
                <div class="item" @click="changeLanguage('en')">
                    <div :class="{'currentBg': $i18n.locale=='en'}"></div>
                    <span :class="{'current': $i18n.locale=='en'}">
                        English
                    </span>
                    
                </div>
            </div>
            <div class="info">
                <img src="../img/clockicon.png" alt="">
                <span class="time">2019年12月9-10日</span>
                <img src="../img/location.png" class="location" alt="">
                <span>
                    中国 • 长沙
                </span>
            </div>
            <div class="organizer">
                    主办单位：中华人民共和国教育部&nbsp;&nbsp; 湖南省人民政府
            </div>
            <div class="organizer_1">
                承办单位：孔子学院总部 &nbsp;&nbsp;世界汉语教学学会
            </div>
            <div class="organizer_1">
                湖南省教育厅 &nbsp;&nbsp;长沙市人民政府等
            </div>
            <div class="copyRight">
                版权所有 © 2019 孔子学院总部
            </div>
        </div>
        <img src="../img/m/arrow_down.png" alt="" class="arrowDown">
    </div>
</template>

<script>
import { setup } from "../../locales";
export default {
    name: 'm_home',
    components: {
        
    },
    data: function () {
        return {
            navbarShow: false
        }
    },
    computed: {
  },
    methods: {
    // 切换语言
    changeLanguage(language) {
        setup(language)
    },
    setDefaultLanguage() {
      let currentLanguage = window.localStorage.getItem("localeLanguage")
    },
    showNavBar () {
        this.navbarShow = true
    },
    close () {
        this.navbarShow = false
    }
  },
  mounted: function() {
    //this.setDefaultLanguage()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .top {
        height: 1.4rem;
        line-height: 1.4rem;
        position: relative;
        .logo {
            width: 1.27rem;
            margin: auto 0.34rem;
            vertical-align: middle;
        }
        .menu {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: 0.34rem;
            width: 0.51rem;
            vertical-align: middle;
        }
    }
    .content {
        .title {
            text-align: center;
            margin: 1rem 0;
            img {
                width: calc(100% - 1rem);
                
            }
            .topic {
                font-size: 0.35rem;
                color: #fff;
                letter-spacing: 0.08em;
                margin-top: 0.8rem;
            }
            .enTopic {
                color: #fff;
                font-size: 0.28rem;
                padding: 0.2rem 0.6rem;
            }
        }
        .language {
            margin-top: 1.34rem;
            .item {
                text-align: center;
                position: relative;
                width: 2.79rem;
                height: 0.8rem;
                margin: 0 auto 0.4rem;
                
                span {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    display: inline-block;
                    text-align: center;
                    width: 2.79rem;
                    height: 0.8rem;
                    line-height: 0.8rem;
                    color: #fff;
                    opacity: 0.7;
                }
                .current {
                    color: #f3bc65;
                    opacity: 1;
                }

                .currentBg {
                    position: absolute;
                    width: 2.79rem;
                    height: 0.8rem;
                    background-image: url(../img/m/current_language_bg.png);
                    background-size: 100%;
                    
                }
                
            }
        }
        .info {
            margin-top: 0.8rem;
            text-align: center;    
            span {
                font-size: 0.26rem;
                color: #fff;
                vertical-align: middle;
            }
            img {
                width: 0.38rem;
                vertical-align: top;
                margin: 0 0.17rem 0 0;
            }
            .location {
                width: 0.28rem;
                margin: 0 0.17rem 0 0.57rem;
            }
            
        }
        .organizer,.organizer_1 {
            text-align: center;
            color: #fff;
            font-size: 0.28rem;
            line-height: 1.2;
        }
        .organizer {
            margin-top: 0.65rem;
            margin-bottom: 0.1rem;
        }
        .copyRight {
            font-size: 0.22rem;
            color: #fff;
            opacity: 0.5;
            text-align: center;
            margin-top: 0.58rem;
        }
    }
    .arrowDown {
        position: absolute;
        bottom: 0.48rem;
        left: 0;
        right: 0;
        width: 0.28rem;
        margin: auto;
        animation: rotation 0.8s infinite alternate-reverse;
    }
    .secondPage {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-image: url(../img/m/m_bg.png);
        background-size: cover;
    }
}
@-webkit-keyframes rotation {
    from {transform: translateY(0)}
    to   {transform: translateY(5px)}
}
</style>
